import React, { useCallback, useState } from 'react'
import { TabNavigation, TabNavigationItem } from '@pandiafi/design-system'
import { useLocation, useNavigate } from 'react-router-dom'

interface NavRoute {
  path: string
  label: string
}

interface NavBarProps {
  routes: NavRoute[]
}

export const NavBar: React.FC<NavBarProps> = ({ routes }) => {
  const location = useLocation()
  const [activeRoute, setActiveRoute] = useState(location.pathname)
  const navigate = useNavigate()

  const handleTabChange = useCallback(
    (path: string) => {
      setActiveRoute(path)
      navigate(path)
    },
    [navigate]
  )

  return (
    <TabNavigation fullwidth onChange={handleTabChange} selected={activeRoute}>
      {routes.map((route) => (
        <TabNavigationItem
          key={route.path}
          id={route.path}
          onPress={() => handleTabChange(route.path)}
        >
          {route.label}
        </TabNavigationItem>
      ))}
    </TabNavigation>
  )
}
